<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col px-0">
        <div class="select_container" style="float:left">
          <select required class="form-control" v-bind:id="'select_procedure' +  getId()" data-fouc>
            <option value="" style="">{{placeholder}}</option>
            <option v-for="option in items" v-bind:value="option.Id">
              {{ option.Name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  var items = [];
  var itemName = "";

  export default {
    name: "category-and-tag-selector",
    props: {
      placeholder: {
        type: String,
        default: "Select Procedure"
      },
    },
    data() {
      return {
        itemName,
        items,
      };
    },
    methods: {
      clearFields() {
        $("#select_procedure" + this.getId()).val('');
        $("#select_procedure" + this.getId()).trigger('change');
      },
      selectProcedure(selected) {
        $("#select_procedure" + this.getId()).val(selected);
        $("#select_procedure" + this.getId()).trigger('change');
      },
      onChange() {
        var theVal = $("#select_procedure" + this.getId()).val()
        var id = -1;
        var type = "";
        if (theVal != null && theVal != "") {
          var arr = theVal.split("_");
          type = arr[0];
          id = arr[1];
          this.$emit('event-change-procedure', type, id);
        } else {
          this.$emit('event-change-procedure', undefined, undefined);
        }
      },
      getId() {
        return this._uid;
      },
      doChange() {
      },
      async load() {
        try {
          this.items = [];
          this.$http.get('/api/Procedures/v1/GetCategoriesAndTags').then(async response => {


            for (var i = 0; i < response.data.length; i++) {
              response.data[i].Id = response.data[i].Type + "_" + response.data[i].Id;
              if (response.data[i].Type == "category") {
                response.data[i].Name = this.$t('procedure_category') + ": " + response.data[i].Name;
              }
              else if (response.data[i].Type == "tag") {
                response.data[i].Name = this.$t('tag') + ": " + response.data[i].Name;
              }
            }


            this.items = response.data;

            if (this.items !== null && this.items.length > 0) {
              this.items = this.items.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }


            $('#' + 'select_procedure' + this.getId()).select2();

          }).then((async response => {
            //$("#select_procedure" + this.getId()).val(selected);
            //$("#select_procedure" + this.getId()).trigger('change');
          }
          ));
        } catch (err) {
          //alert('some error:' + err)
        }
      }
    },
    watch: {

    },
    mounted() {
      this.load();
      this.placeholder = this.$store.translate('select_template');
      $("#select_procedure" + this.getId()).change(this.onChange);
    }
  };
</script>

<style scoped>
  .select_container {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/procedure/category-and-tag-selector.vue